export default {
      id: "icon-timerthermor-usage",
      viewBox: "0 0 25 30",
      url: __webpack_public_path__ + "icons.svg#icon-timerthermor",
      toString: function () {
        return this.url;
      }
    }